<script setup lang="ts">
import { watch, ref } from 'vue'
import { t } from '@/locales/i18n'
import * as R from 'remeda'
import GwTooltipNew from '@/components/lib/GwTooltip.vue'

const l_value = ref('')

type Props = {
  value?: string
  placeholder?: string
}

const props = defineProps<Props>()
const emit = defineEmits(['update:value'])

const handleInput = (e: Event) => {
  l_value.value = (e.target as HTMLInputElement).value
  emit('update:value', l_value.value)
}

const clearInput = () => {
  l_value.value = ''
  emit('update:value', '')
}

watch(
  () => props.value,
  newValue => {
    l_value.value = newValue || ''
  },
  { immediate: true },
)
</script>

<template>
  <div class="gwinput gw_input_wrapper">
    <input
      class="gwinput_input"
      :value="l_value"
      :placeholder="placeholder || t(`common.search`)"
      type="text"
      spellcheck="false"
      autocomplete="off"
      data-tst="gw_input"
      @input="handleInput"
      @keydown.stop.escape.exact.prevent="clearInput"
    />
    <div
      v-if="!l_value"
      class="gwinput_icon mdi mdi-magnify"
    />
    <div
      v-else
      class="gwinput_clear"
      data-tst="gw_input_clear"
      @click="clearInput"
    >
      <GwTooltipNew
        :isInside="true"
        icon="mdi-close pa-1 icon_btn clr-grey clr-hover_white"
        :tooltip="t('common.clear_key', { key: 'Esc' })"
      >
      </GwTooltipNew>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.gwinput {
  --input-border-width: 1px;
  --input-height: 2rem;
  --input-border-radius: 6px;
  --input-padding: 0 2rem;

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &_input {
    padding: 0 2rem 0 0.5rem;
    background: var(--app-dark-1);
  }
  &_icon {
    position: absolute;
    right: 0.5rem;
    font-size: 1.25em;
    color: var(--app-clr-grey-2);
  }
  &_clear {
    font-size: 1.25em;
    position: absolute !important;
    right: 0.25rem;
    cursor: pointer;
  }
}
</style>
